export default "__VITE_ASSET__Bk13rQ$p__"